import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {error} from '..';
import {ProductsService} from '../services/products-List.service';
import {L10nTranslationService} from 'angular-l10n';
import {billingProductsActionTypes, LoadBillingProductsFailAction, LoadBillingProductsSuccessAction} from '../actions/billing-product';
import {BillingProduct} from '../models/product';

@Injectable()
export class BillingProductEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(billingProductsActionTypes.LOAD),
    debug('Products load action received.'),
    switchMap(() => this.productsService.getBillingList().pipe(
      map((payload: SendBackResult<ArrayResponse<BillingProduct>>) => new LoadBillingProductsSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)),
    )),
  ) });

  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(billingProductsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving products list.'),
    map((action: LoadBillingProductsFailAction) =>
      error(this.translation.translate('PRODUCTS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  ) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private productsService: ProductsService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadBillingProductsFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadBillingProductsFailAction(response['error'].message);
  }
}
